/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exclusive_AccessInputs */

const en_exclusive_access = /** @type {(inputs: Exclusive_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exclusive Access`)
};

const es_exclusive_access = /** @type {(inputs: Exclusive_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso Exclusivo`)
};

const fr_exclusive_access = /** @type {(inputs: Exclusive_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès exclusif`)
};

const de_exclusive_access = /** @type {(inputs: Exclusive_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exklusiver Zugang`)
};

const id_exclusive_access = /** @type {(inputs: Exclusive_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses Eksklusif`)
};

/** @type {(inputs: Exclusive_AccessInputs) => LocalizedString} */
const ja_exclusive_access = en_exclusive_access;

/** @type {(inputs: Exclusive_AccessInputs) => LocalizedString} */
const zh_exclusive_access = en_exclusive_access;

/** @type {(inputs: Exclusive_AccessInputs) => LocalizedString} */
const ar_exclusive_access = en_exclusive_access;

/** @type {(inputs: Exclusive_AccessInputs) => LocalizedString} */
const it_exclusive_access = en_exclusive_access;

/** @type {(inputs: Exclusive_AccessInputs) => LocalizedString} */
const ru_exclusive_access = en_exclusive_access;

/** @type {(inputs: Exclusive_AccessInputs) => LocalizedString} */
const pt_exclusive_access = en_exclusive_access;

/** @type {(inputs: Exclusive_AccessInputs) => LocalizedString} */
const ko_exclusive_access = en_exclusive_access;

/**
* | output |
* | --- |
* | "Exclusive Access" |
*
* @param {Exclusive_AccessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const exclusive_access = /** @type {((inputs?: Exclusive_AccessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exclusive_AccessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exclusive_access(inputs)
	if (locale === "es") return es_exclusive_access(inputs)
	if (locale === "fr") return fr_exclusive_access(inputs)
	if (locale === "de") return de_exclusive_access(inputs)
	if (locale === "ja") return ja_exclusive_access(inputs)
	if (locale === "zh") return zh_exclusive_access(inputs)
	if (locale === "ar") return ar_exclusive_access(inputs)
	if (locale === "id") return id_exclusive_access(inputs)
	if (locale === "it") return it_exclusive_access(inputs)
	if (locale === "ru") return ru_exclusive_access(inputs)
	if (locale === "pt") return pt_exclusive_access(inputs)
	return ko_exclusive_access(inputs)
});